import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../services/api';
import { toast } from 'react-toastify';
import '../../components/admin/AdminLayout.css';

const AdminPromoters = () => {
  const [promoters, setPromoters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPromoters();
  }, []);

  const fetchPromoters = async () => {
    try {
      const response = await api.get('/admin/promoters');
      setPromoters(response.data);
    } catch (error) {
      toast.error('Failed to fetch promoters');
    } finally {
      setLoading(false);
    }
  };

  const handleRevoke = async (userId) => {
    if (!window.confirm('Are you sure you want to revoke promoter status?')) return;
    
    try {
      await api.delete(`/admin/promoters/${userId}`);
      toast.success('Promoter status revoked');
      fetchPromoters();
    } catch (error) {
      toast.error('Failed to revoke promoter status');
    }
  };

  const getExpiryStatus = (promoter) => {
    if (!promoter.promoterExpiresAt) {
      return <span className="admin-badge active">Lifetime</span>;
    }
    
    const expiresAt = new Date(promoter.promoterExpiresAt);
    const now = new Date();
    
    if (expiresAt < now) {
      return <span className="admin-badge suspended">Expired</span>;
    }
    
    const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
    
    if (daysLeft <= 7) {
      return <span className="admin-badge" style={{ background: '#fef3c7', color: '#d97706' }}>
        {daysLeft} days left
      </span>;
    }
    
    return <span className="admin-badge active">
      Until {expiresAt.toLocaleDateString()}
    </span>;
  };

  const getPromoterTypeBadge = (type) => {
    const colors = {
      friend: { bg: '#dbeafe', color: '#1d4ed8' },
      influencer: { bg: '#fce7f3', color: '#be185d' },
      beta_tester: { bg: '#d1fae5', color: '#059669' },
      contest: { bg: '#fef3c7', color: '#d97706' },
      support: { bg: '#ede9fe', color: '#7c3aed' },
      other: { bg: '#f3f4f6', color: '#6b7280' }
    };
    
    const style = colors[type] || colors.other;
    const labels = {
      friend: 'Friend/Family',
      influencer: 'Influencer',
      beta_tester: 'Beta Tester',
      contest: 'Contest Winner',
      support: 'Support',
      other: 'Other'
    };
    
    return (
      <span 
        className="admin-badge" 
        style={{ background: style.bg, color: style.color }}
      >
        {labels[type] || type}
      </span>
    );
  };

  return (
    <AdminLayout>
      <div className="admin-table-container">
        <div className="admin-table-header">
          <div className="admin-table-title">
            Promoters ({promoters.length})
          </div>
          <p style={{ margin: 0, color: '#6b7280' }}>
            Users with free premium access
          </p>
        </div>

        {loading ? (
          <div className="admin-loading">Loading promoters...</div>
        ) : promoters.length === 0 ? (
          <div className="admin-empty">
            <div className="admin-empty-icon">🎁</div>
            <p>No promoters yet</p>
            <p style={{ color: '#6b7280' }}>Grant promoter status from the Users page</p>
          </div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Type</th>
                <th>Status</th>
                <th>Granted By</th>
                <th>Notes</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {promoters.map((promoter) => (
                <tr key={promoter._id}>
                  <td>
                    <div>
                      <strong>{promoter.firstName} {promoter.lastName}</strong>
                      <br />
                      <small style={{ color: '#6b7280' }}>{promoter.email}</small>
                    </div>
                  </td>
                  <td>{getPromoterTypeBadge(promoter.promoterType)}</td>
                  <td>{getExpiryStatus(promoter)}</td>
                  <td>
                    {promoter.promoterGrantedBy ? (
                      <span>
                        {promoter.promoterGrantedBy.firstName} {promoter.promoterGrantedBy.lastName}
                        <br />
                        <small style={{ color: '#6b7280' }}>
                          {new Date(promoter.promoterGrantedAt).toLocaleDateString()}
                        </small>
                      </span>
                    ) : (
                      <span style={{ color: '#6b7280' }}>Unknown</span>
                    )}
                  </td>
                  <td>
                    <span style={{ 
                      color: '#6b7280', 
                      maxWidth: '200px', 
                      display: 'block',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      {promoter.promoterNotes || '-'}
                    </span>
                  </td>
                  <td>
                    <button
                      onClick={() => handleRevoke(promoter._id)}
                      className="admin-btn admin-btn-danger admin-btn-small"
                    >
                      Revoke
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminPromoters;
